// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const UsersIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M8.72 13.64q-7.22 0-7.22 4.27c0 1.64 1.2 2.84 2.73 2.84h8.97c1.54 0 2.63-1.1 2.74-2.84q0-4.27-7.22-4.27m0-2.3c2.3 0 4.05-1.75 4.05-4.04s-1.75-4.05-4.05-4.05S4.67 5 4.67 7.3c-.1.98.33 1.97 1.1 2.73.76.88 1.86 1.31 2.95 1.31" />
      <path
        d="M17.58 13.86c-.33 0-.66.1-.77.44-.1.22-.1.65 0 .87 1.1 1.64.99 3.17.55 4.05-.1.22-.1.55.1.76.12.22.45.33.67.33h1.75c1.53 0 2.62-1.1 2.62-2.73 0-3.4-3.72-3.72-4.92-3.72m-.11-2.41c1.75 0 3.06-1.31 3.06-3.17s-1.31-3.17-3.06-3.17-3.17 1.31-3.17 3.17 1.42 3.17 3.17 3.17"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default UsersIcon;
